// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3isyE","col":"styles_col__3_n4-"};